import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import { OrganizationRow } from 'components/tables/data/organization/types';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';
import { useCallback, useEffect, useState } from 'react';

/** Parameters supplied by the organization table to its hierarchy floating filter. */
export interface HierarchySelectFilterProps {
  api: GridApi<OrganizationRow>;
  onChange?: FilterChangeCallback;
}

/** Floating select filter containing the effective hierarchies present in organization rows. */
export default function HierarchySelectFilter({ api, onChange }: HierarchySelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: 'hierarchyName', onChange });
  const [options, setOptions] = useState<Array<{ value: string; label: string }>>([]);

  const updateOptions = useCallback(() => {
    const names = new Set<string>();
    api.forEachNode(({ data }) => {
      if (data?.hierarchyName) names.add(data.hierarchyName);
    });
    setOptions(
      [...names]
        .sort((left, right) => left.localeCompare(right, 'sk'))
        .map((hierarchyName) => ({ value: hierarchyName, label: hierarchyName }))
    );
  }, [api]);

  useEffect(() => {
    updateOptions();
    api.addEventListener('rowDataUpdated', updateOptions);
    return () => api.removeEventListener('rowDataUpdated', updateOptions);
  }, [api, updateOptions]);

  return (
    <Select
      clearable
      searchable
      w="100%"
      size="sm"
      placeholder="Všetky hierarchie"
      data={options}
      value={value}
      onChange={setValue}
    />
  );
}
